"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = exports.RenderFormField = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const FormField_1 = require("@reactionable/core/lib/form/FormField");
const FormCheck_1 = tslib_1.__importDefault(require("react-bootstrap/FormCheck"));
const FormControl_1 = tslib_1.__importDefault(require("react-bootstrap/FormControl"));
const FormGroup_1 = tslib_1.__importDefault(require("react-bootstrap/FormGroup"));
const FormLabel_1 = tslib_1.__importDefault(require("react-bootstrap/FormLabel"));
const FormErrorMessage_1 = require("./FormErrorMessage");
function RenderFormField(_a) {
    var { isValid, isInvalid } = _a, _b = _a.field, { label } = _b, field = tslib_1.__rest(_b, ["label"]);
    let input;
    const fieldProps = Object.assign(Object.assign({}, field), { isValid,
        isInvalid });
    const labelContent = FormField_1.getFormFieldLabelContent(label, field.required);
    if (field.type === "checkbox") {
        input = jsx_runtime_1.jsx(FormCheck_1.default, Object.assign({}, fieldProps, { label: labelContent }), void 0);
    }
    else {
        input = jsx_runtime_1.jsx(FormControl_1.default, Object.assign({}, fieldProps), void 0);
        if (labelContent) {
            input = (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(FormLabel_1.default, { children: labelContent }, void 0), input] }, void 0));
        }
    }
    const fieldContent = (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [input, jsx_runtime_1.jsx(FormErrorMessage_1.FormErrorMessage, { name: fieldProps.name }, void 0)] }, void 0));
    if (field.type === "hidden") {
        return fieldContent;
    }
    return jsx_runtime_1.jsx(FormGroup_1.default, Object.assign({ controlId: field.name }, { children: fieldContent }), void 0);
}
exports.RenderFormField = RenderFormField;
function FormField(props) {
    return jsx_runtime_1.jsx(FormField_1.FormField, Object.assign({}, props, { render: RenderFormField }), void 0);
}
exports.FormField = FormField;
//# sourceMappingURL=FormField.js.map